// src/components/TermsModal.jsx
import React from 'react'
import ReactDOM from 'react-dom'
import { X } from 'lucide-react'

export function TermsModal({ onClose }) {
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9100,
      padding: '16px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        width: '100%',
        maxWidth: 560,
        maxHeight: '88vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.22)',
        overflow: 'hidden',
      }}>
        {/* ヘッダー（固定） */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 20px 14px',
          borderBottom: '1px solid #f3f4f6',
          flexShrink: 0,
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>
            利用規約
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#6b7280', padding: 6, borderRadius: 8,
              display: 'flex', alignItems: 'center',
            }}
          >
            <X size={22} />
          </button>
        </div>

        {/* コンテンツ（スクロール可能） */}
        <div style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: '18px 20px 24px',
          fontSize: 13,
          lineHeight: 1.85,
          color: '#374151',
        }}>
          <p style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#1a1a2e', textAlign: 'center' }}>
            HowToon 利用規約
          </p>

          <Section title="第1条（適用）">
            本規約は、sens1204（以下「運営者」）が提供する「HowToon」（以下「本サービス」）の利用条件を定めるものです。利用者は、本サービスを利用することにより、本規約に同意したものとみなされます。
          </Section>

          <Section title="第2条（定義）">
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>「クリエイター」とは、本サービスにハウツー（手順、知見、画像等）を投稿する利用者を指します。</li>
              <li>「ユーザー」とは、本サービスを閲覧または利用するすべての利用者を指します。</li>
            </ol>
          </Section>

          <Section title="第3条（アカウント）">
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>本サービスはGoogleアカウントによる認証を利用します。</li>
              <li>未成年者が本サービスを利用する場合は、法定代理人の同意を得るものとします。</li>
              <li>運営者は、利用者が本規約に違反したと判断した場合、事前通知なくアカウント停止、削除、利用制限を行うことができます。</li>
            </ol>
          </Section>

          <Section title="第4条（著作権およびコンテンツの取扱い）">
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>クリエイターが投稿したコンテンツの著作権は、当該クリエイターに帰属します。</li>
              <li>クリエイターは運営者に対し、本サービスの提供、プロモーション、機能改善、安全確認の目的において、投稿内容を無償・非独占的に利用（複製・加工・表示・翻訳等）することを許諾するものとします。</li>
              <li>利用者は、自らが投稿するコンテンツについて、第三者の権利を侵害していないことを保証するものとします。</li>
              <li>本サービスは、サービス運営および維持を目的として、Amazonアソシエイト・プログラムを利用しています。利用者が投稿内にAmazonの商品リンクを含めた場合、当該リンクには本サービスのアソシエイトIDが自動的に付与され、これによる紹介料等は運営者に帰属するものとします。</li>
              <li>前項の場合、関連法令およびガイドライン（景品表示法等）に基づき、広告であることを示す表記（「(PR)」等）がシステムにより自動的に追加されます。</li>
              <li>利用者は、前二項の処理がシステムにより自動的に行われることについてあらかじめ同意のうえ、投稿を行うものとします。</li>
            </ol>
          </Section>

          <Section title="第5条（投稿の管理および通報）">
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>ユーザーは、不適切な投稿を本サービス所定の方法により通報することができます。</li>
              <li>運営者は、本サービスの健全性維持のため、自動解析システムまたは人的確認による監査を行うことがあります。</li>
              <li>運営者は、違反があると判断した投稿について、事前通知なく削除、非公開化、利用制限を行うことができます。</li>
            </ol>
          </Section>

          <Section title="第6条（禁止事項）">
            <p style={{ margin: '0 0 8px' }}>利用者は以下の行為を行ってはなりません。</p>
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>他者の知的財産権、名誉、プライバシーを侵害する行為</li>
              <li>虚偽情報または重大な危険を伴う手順を適切な注意喚起なく投稿する行為</li>
              <li>スパム行為または監査機能を回避する行為</li>
              <li>投稿リンクの自動変換機能や広告明示（PR表記等）の仕組みを、不正に回避、改変、または隠蔽する行為。</li>
              <li>公序良俗に反する行為</li>
              <li>本サービスの運営を妨害する行為</li>
              <li>その他、運営者が不適切と判断する行為</li>
            </ol>
          </Section>

          <Section title="第7条（免責事項）">
            <ol style={{ margin: 0, paddingLeft: 20 }}>
              <li>運営者は、投稿内容の正確性、有用性、安全性について一切保証しません。</li>
              <li>利用者が本サービス上の情報を利用したことにより生じた損害について、運営者は故意または重過失がある場合を除き責任を負いません。</li>
              <li>本サービスの中断、停止、終了、データ消失等により生じた損害について、運営者は責任を負いません。</li>
              <li>本サービスは、Amazonアソシエイト・プログラムその他の第三者サービスを利用することがあります。外部サービスの仕様変更、停止、内容変更等により生じた損害について、運営者は責任を負いません。</li>
              <li>運営者が責任を負う場合でも、その範囲は直接かつ通常の損害に限られます。</li>
              <li>本サービスは随時アップデートが行われる開発途上のサービスであり、運営者は本サービスの継続性、完全性、および特定の環境下での動作を保証しません。</li>
            </ol>
          </Section>

          <Section title="第8条（規約の変更）">
            運営者は、必要に応じて本規約を変更することができます。変更後の規約は、本サービス上に掲載された時点で効力を生じます。
          </Section>

          <Section title="第9条（準拠法・管轄）">
            本規約は日本法に準拠します。本サービスに関する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </Section>

          <p style={{ marginTop: 24, color: '#9ca3af', fontSize: 12 }}>
            制定日：2026年2月20日　改定日：2026年2月27日
          </p>
        </div>
      </div>
    </div>,
    document.body
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>
        {title}
      </h3>
      <div>{children}</div>
    </div>
  )
}
